import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/esm/Card'
import Controllers from '../../Api/Controllers'
import ReactPlaceholder from 'react-placeholder/lib'
import Helpers from '../../Components/Helpers/Helpers'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap'
import Modal from 'react-bootstrap/Modal'

const MetricCard = ({ ready, label, children, className = '', success = false }) => (
    <Card className={`ui-metric-card mb-0 ${success ? 'is-success' : ''} ${className}`.trim()}>
        <Card.Body className="text-center d-flex flex-column height-100 position-relative justify-content-center">
            <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                <span className="ui-metric-label">{label}</span>
                <div className="ui-metric-value">{children}</div>
            </ReactPlaceholder>
        </Card.Body>
    </Card>
)

const Dashboard = _ => {
    const [summary, setSummary] = useState([])
    const [ready, setReady] = useState(false)
    const [rows, setRows] = useState([])

    const [modalShow, setModalShow] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [isProcessing, setIsProcessing] = useState(false)

    useEffect(() => {
        Controllers.dashboard.get_customers_summary().then(res => {
            setSummary(res.data)
            setReady(true)
        })
    }, [])

    const dtRowsDetails = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_customers', text: 'ID', align: 'center' },
                { name: 'full_name_customers', text: 'Nombres', align: 'center' }
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    const loadRowsDetails = e => {
        const { type } = e.currentTarget.dataset

        setRows([])
        setModalShow(true)
        setIsProcessing(true)
        let promises = []
        if (type === 'first') {
            setModalTitle('Descendencia Primer Nivel')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 1
            }))
        } else if (type === 'second') {
            setModalTitle('Descendencia Segundo Nivel')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 2
            }))
        } else if (type === 'third') {
            setModalTitle('Descendencia Tercer Nivel')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 3
            }))
        } else if (type === 'fourth') {
            setModalTitle('Descendencia Cuarto Nivel')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 4
            }))
        } else if (type === 'fifth') {
            setModalTitle('Descendencia Quinto Nivel')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 5
            }))
        } else if (type === 'sixth') {
            setModalTitle('Descendencia Sexto Nivel - Infinito')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 6,
                p_up: 1
            }))
        } else if (type === 'all') {
            setModalTitle('Descendencia Primer Nivel - Infinito')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 1,
                p_up: 1
            }))
        } else if (type === 'notMinPoint') {
            setModalTitle('Consultores que no llegaron a puntos mínimos')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 1,
                p_up: 1,
                p_qualifier: 0
            }))
        } else if (type === 'two-months') {
            setModalTitle('Consultores inactivos por más de 2 meses')
            promises.push(Controllers.dashboard.get_customers_last_purchase_two_months())
        }

        if (promises.length) {
            Promise.all(promises).then(res => {
                setRows(res[0].data)
                setIsProcessing(false)
            })
        }
    }

    const pointsQualified = parseInt(summary.point_current_customers?.replace(',', '')) >= Helpers.config.pointMinRange

    const InfoIcon = ({ type }) => (
        <i
            className="fas fa-info-circle ml-2 text-info cur-pointer align-self-center"
            data-type={type}
            onClick={loadRowsDetails}
            style={{ fontSize: '0.95rem' }}
        />
    )

    return <div className="form-row">
        <div className="col-12 mb-3">
            <div className="d-flex flex-column flex-sm-row justify-content-between" style={{ gap: 12 }}>
                <Card className="ui-metric-card is-primary mb-0" style={{ minWidth: 250, flex: 1 }}>
                    <Card.Body className="text-center d-flex flex-column height-100 justify-content-center">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="ui-metric-label">Consultor</span>
                            <div className="ui-metric-value" style={{ fontSize: '1rem' }}>
                                ID {summary.id_customers} · {summary.full_name_customers}
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
                <Card className="ui-metric-card is-primary mb-0 align-self-stretch" style={{ minWidth: 220 }}>
                    <Card.Body className="text-center d-flex flex-column justify-content-center">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={1}>
                            <span className="ui-metric-label">Período</span>
                            <div className="ui-metric-value" style={{ fontSize: '1rem' }}>{summary.name_period}</div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
        </div>

        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Puntos" success={pointsQualified}>
                {summary.point_current_customers}
                {pointsQualified ? (
                    <div className="mt-2" style={{ fontSize: '0.75rem', fontWeight: 600 }}>
                        ¡FELICIDADES! Ya calificaste.
                    </div>
                ) : null}
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Valor Negocio">
                {summary.point_business_customers}
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Rango">
                {summary.icon_plan ? (
                    <img
                        src={Helpers.config.resourcesUrl({ url: summary.icon_plan })}
                        alt={summary.name_plan || 'Rango'}
                        style={{ maxWidth: 88, maxHeight: 72, objectFit: 'contain' }}
                    />
                ) : (
                    <strong>{summary.name_plan}</strong>
                )}
            </MetricCard>
        </div>

        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Calificados 1er Nivel">
                <span className="d-inline-flex align-items-center justify-content-center">
                    {summary.qualifier_first_nivel}
                    <InfoIcon type="first" />
                </span>
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Calificados 2do Nivel">
                <span className="d-inline-flex align-items-center justify-content-center">
                    {summary.qualifier_second_nivel}
                    <InfoIcon type="second" />
                </span>
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Calificados 3er Nivel">
                <span className="d-inline-flex align-items-center justify-content-center">
                    {summary.qualifier_third_nivel}
                    <InfoIcon type="third" />
                </span>
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Calificados 4to Nivel">
                <span className="d-inline-flex align-items-center justify-content-center">
                    {summary.qualifier_fourth_nivel}
                    <InfoIcon type="fourth" />
                </span>
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Calificados 5to Nivel">
                <span className="d-inline-flex align-items-center justify-content-center">
                    {summary.qualifier_fifth_nivel}
                    <InfoIcon type="fifth" />
                </span>
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Calificados 6to Nivel-Infinito">
                <span className="d-inline-flex align-items-center justify-content-center">
                    {summary.qualifier_sixth_nivel}
                    <InfoIcon type="sixth" />
                </span>
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Puntos Grupales de toda la Red">
                {summary.point_group_red}
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Puntos Grupales del 5to Nivel al Infinito">
                {summary.qualifier_group_fifth_nivel}
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Personas inactivas por más de 2 meses">
                <span className="d-inline-flex align-items-center justify-content-center">
                    {summary.qty_customers_inactive_two_months}
                    <InfoIcon type="two-months" />
                </span>
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Cantidad de Consultores en tu Red Activos e Inactivos">
                <span className="d-inline-flex align-items-center justify-content-center">
                    {summary.qty_customers_active_and_inactive}
                    <InfoIcon type="all" />
                </span>
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Consultores que han comprado, pero no han alcanzado los 1500 puntos de calificación">
                <span className="d-inline-flex align-items-center justify-content-center">
                    {summary.qty_customers_without_min_points}
                    <InfoIcon type="notMinPoint" />
                </span>
            </MetricCard>
        </div>
        <div className="col-md-4 col-12 col-sm-6 mb-3">
            <MetricCard ready={ready} label="Total de Comisiones Cobradas">
                {summary.total_earnings}
            </MetricCard>
        </div>

        <Modal show={modalShow} onHide={_ => setModalShow(false)} backdrop="static" size="lg">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {dtRowsDetails}
            </Modal.Body>
        </Modal>
    </div>
}

export default Dashboard
